<template>
  <div>
    <section class="nav">
        <div class="nav-holder-div">
            <div class="nav-bar-div w-clearfix" style="display:block;">
                <a href="#" class="brand w-nav-brand"><img sizes="84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" src="@/assets/images/Main_Logo.png" loading="lazy" class="image-389" style="height: 22px;"></a>
                <div class="div-block-1714 addtopmargin">
                    <a href="/login?page_ref=productPage" title="Log in to your account" class="link-block-51 w-inline-block" v-if="!isLoggedin"></a>
                    <a href="#" class="link-block-68 w-inline-block" title="Log out" @click.prevent="logoutUser"  v-else>
                      LOGOUT&nbsp;&nbsp;
                    </a>
                </div>
            </div>
        </div>
    </section>
    <section>
      <div class="portal-top-div">
        <div class="w-layout-blockcontainer portal-tab-container w-container">
          <div class="text-block-914">Hi, {{ first_name }}</div>
          <div class="w-tabs">
            <TabContainer
              :user="user"
              :baseUrl="baseUrl"
              :computedProps="dashboardComputedProps"
              :activeTab="currentTab"
              @tab-change="handleTabChange"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import TabContainer from './TabContainer.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'HomePage',

    components: {

        TabContainer
    },

    props: ["stripeKey"],

    data() {
        return {
            currentTab: 'orders',
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            excludedTirMedIds: [
                'efae95c2-7f01-4d6a-b50f-70142d39018a',
                '2179880a-52d0-4148-96b3-3ccf4548dc44',
                '7861bbf4-06d7-4f76-baba-f78809dd9279',
                '543f3035-b1d4-485b-97b9-db1ec0972d58',
                '382db5bb-fa90-43bb-bd33-bfe772340130',
                '04b6a9aa-63dc-4124-bddc-cbc9330eb77f'
            ]
        };
    },

    computed: {
        ...mapGetters(['user', 'getLatestPrescription', 'getCase', 'getOrdersWithPrescriptions', 'progressItems', 'subscriptionItems']),

        first_name() {
            try {
                return this.user.first_name;
            } catch (error) {
                console.log(error);
                return "";
            }
        },
        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },
        checkCreated() {
            try {
                console.log(this.user.created_at);
                const createdAt = new Date(this.user.created_at);
                const comparisonDate = new Date("2025-04-09T20:33:52.956Z");
                return createdAt < comparisonDate;
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        
        hasPrescription() {
            return Array.isArray(this.getLatestPrescription) && this.getLatestPrescription.length > 0;
        },
        
        hasSemaglutide() {
            try {
                return this.subscriptionItems.some(item => 
                    item.plan_name === "Semaglutide" && item.payment_terms !== 12
                );
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        
        hasCase() {
            return !!this.getCase && this.getCase.provider === 1;
        },

        noTirRefill() {
            if (!this.hasPrescription) return false;

            if (Array.isArray(this.progressItems) && this.progressItems.length > 1) {
                return false;
            }
            
            const tirzepatidePrescriptions = this.getLatestPrescription.filter(prescription =>
                prescription.name && prescription.name.toLowerCase().includes('tirzepatide')
            );

            if (tirzepatidePrescriptions.length === 0) return false;

            const hasExcludedMedId = tirzepatidePrescriptions.some(prescription =>
                this.excludedTirMedIds.includes(prescription.medId)
            );

            return !hasExcludedMedId;
        },
        
        dashboardComputedProps() {
            return {
                hasPrescription: this.hasPrescription,
                hasSemaglutide: this.hasSemaglutide,
                hasCase: this.hasCase,
                noTirRefill: this.noTirRefill,
                checkCreated: this.checkCreated
            };
        }
    },
    watch: {
        hasPrescription(newValue) {
            if (!newValue && this.currentTab === 'dosage') {
                this.currentTab = 'orders';
            }
        }
    },
    mounted() {
        
    },
    methods: {
        logoutUser(){
       
            this.$axios.get(this.baseUrl + '/api/logout').then(response => {
                if (response.data.status == 'success') {
                    localStorage.removeItem('_ymain_key_');
                    window.location.reload();
                }
            }).catch(error => {
                console.log(error);
                localStorage.removeItem('_ymain_key_');
                window.location.reload();
            });
    },
        handleTabChange(tabId) {
            this.currentTab = tabId;
            this.$store.dispatch('setActiveHomeTab', tabId);
        }
    },

    created() {
        window.scroll(0, 0)
    }
}
</script>

<style scoped>
.portal-top-div {
  padding: 20px 0;
}

.portal-tab-container {
  margin: 0 auto;
  padding: 0 20px;
}

.text-block-914 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 30px;
  margin-top:40px;
  color: var(--black);
  font-family: var(--mulish);
}

.w-tabs {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .portal-tab-container {
    padding: 0 15px;
  }
  
  .text-block-914 {
    font-size: 20px;
    margin-bottom: 20px;
  }
}
</style>
